import { Grid } from "@mui/material";
import { useReducer, useState } from "react";
import { Item } from "../../utils/sharedTypes";
import FirmwareFilterBar from "./FirmwareFilterBar";
import FirmwareOptionsBar from "./FirmwareOptionsBar";
import FirmwareTable from "./FirmwareTable";
import { FirmwareFilter } from "./linksTypes";

const initialFilters: FirmwareFilter = {
  hardwareType: null,
  name: undefined,
};

const Firmware = () => {
  const [filters, setFilters] = useReducer(
    (curVals: FirmwareFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );
  const [selectedFirmware, setSelectedFirmware] = useState<Item[]>([]);
  return (
    <>
      <FirmwareFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <Grid container spacing={1}>
        <Grid item>
          <FirmwareOptionsBar
            selectedFirmware={selectedFirmware}
            setSelectedFirmware={setSelectedFirmware}
          />
        </Grid>
      </Grid>
      <FirmwareTable
        setSelectedFirmware={setSelectedFirmware}
        filters={filters}
      />
    </>
  );
};

export default Firmware;
